import { defineStore } from 'pinia';
import { formModule } from '@/stores/form';

const maxChars3000Rule = {
  name: 'function',
  fn: (v) => String(v ?? '').length < 3000,
  errorMessage: 'Must be fewer than 3000 characters',
};

export const useAcknowledgementSettingsForm = defineStore('acknowledgementSettingsForm', () => formModule({
  fields: {
    organization_name: { label: 'Organization Name' },
    acknowledgement_email_intro: {
      label: 'Acknowledgement Email',
      rules: [maxChars3000Rule],
    },
    acknowledgement_agreement_text: {
      label: 'Acknowledgement Agreement',
      rules: [maxChars3000Rule],
    },
    acknowledgement_pdf_text: {
      label: 'Acknowledgement PDF',
      rules: [maxChars3000Rule],
    },
    hr_contact_email: { label: 'HR Contact Email' },
    acknowledgement_cycle_sla: {
      label: 'Acknowledgement Cycle SLA',
      rules: [
        { name: 'positiveInteger', errorMessage: 'Must be a whole number (e.g. 7)' },
      ],
    },
    acknowledgement_pending_sla: {
      label: 'Acknowledgement Reminder Threshold',
      rules: [
        { name: 'positiveInteger', errorMessage: 'Must be a whole number (e.g. 7)' },
      ],
    },
  },
}));
